var SpriteSymbol = require("../../../node_modules/svg-baker-runtime/browser-symbol.js");
var sprite = require("../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");
var symbol = new SpriteSymbol({
  "id": "youtube",
  "use": "youtube-usage",
  "viewBox": "0 0 17 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 17 16\" id=\"youtube\"><path fill=\"#fff\" d=\"m12.692 1.625-9.354-.018C1.503 1.604.012 3.072.01 4.887L0 11.111c-.003 1.816 1.482 3.29 3.317 3.294l9.354.018c1.835.004 3.326-1.466 3.329-3.28l.009-6.225c.003-1.815-1.482-3.29-3.317-3.293m-2.258 6.619L6.054 10.3a.175.175 0 0 1-.25-.158l.007-4.256a.176.176 0 0 1 .256-.154l4.371 2.2a.173.173 0 0 1-.004.313z\" /></symbol>"
});
var result = sprite.add(symbol);
module.exports = symbol